/*
     Title: Constant for ZONE
     Description: Constant for ZONE
     Author: Iqbal Hossain
     Date: 09-January-2022
     Modified: 09-January-2022
*/

export const FETCH_ZONE = 'FETCH_ZONE';
export const TOGGLE_ZONE_SIDEBAR = 'TOGGLE_ZONE_SIDEBAR';
export const TOGGLE_ZONE_STATUS = 'TOGGLE_ZONE_STATUS';
export const FETCH_ZONE_BY_QUERY = 'FETCH_ZONE_BY_QUERY';
export const ADD_ZONE = 'ADD_ZONE';
export const DELETE_ZONE = 'DELETE_ZONE';
export const FETCH_ZONE_BY_ID = 'FETCH_ZONE_BY_ID';
export const UPDATE_ZONE = 'UPDATE_ZONE';
export const DELETE_ZONE_BY_RANGE = 'DELETE_ZONE_BY_RANGE';

/** Change Log
 * 09-Jan-2022(Iqbal): Add TOGGLE_ZONE_SIDEBAR, FETCH_ZONE_BY_QUERY, ADD_ZONE, DELETE_ZONE, FETCH_ZONE_BY_ID, UPDATE_ZONE, DELETE_ZONE_BY_RANGE
 */
